import Global66IntegrationFlow from './Global66IntegrationFlow'

const Global66IntegrationContent = ({ onStatusChange }) => (
  <Global66IntegrationFlow variant="page" onStatusChange={onStatusChange} />
)

export default Global66IntegrationContent
